import { config } from 'shared/config';
import { instance } from 'shared/api/instance';
import { ContentErrors, ContentErrorsEnum } from '../consts/consts.error';
import { ICreateImageDto } from '../interfaces/create-image.params.interface';

const API = instance(config.API_CONTENT);

export class ContentApi {
  public static async createImage(dto: ICreateImageDto): Promise<string> {
    try {
      const url = '/business/upload';

      const formData = new FormData();
      formData.append('file', dto.file);

      const response = await API.post(url, formData);
      return response.data.url;
    } catch (error) {
      const err = error as { response?: { status: number } };
      switch (err.response?.status) {
        case 400:
          throw new Error(ContentErrors.CREATE[400]);
        case 413:
          throw new Error(ContentErrors.CREATE[413]);
        case 500:
          throw new Error(ContentErrors.CREATE[500]);
        default:
          throw new Error(ContentErrorsEnum.CREATE_DEFAULT);
      }
    }
  }
}
